import React, {useState, useEffect} from 'react'
import {Switch, Redirect} from 'react-router-dom'
import {observer, inject} from 'mobx-react'
import RouteWithSubRoutes from '@components/routeWithSubRoutes'
import CockpitHeader from './cockpit-header'
import './index.less'

// 驾驶舱首页
const CockpitHome = inject('store')(
  observer(({store, routes}) => {
    const {userInfo, queryUserInfo} = store
    const [afterLoading, setAfterLoading] = useState(false)

    async function init() {
      try {
        await queryUserInfo()
      } finally {
        setAfterLoading(true)
      }
    }

    useEffect(() => {
      init()
    }, [])

    if (!afterLoading) {
      return null
    }

    if (!userInfo) {
      return <Redirect to="/login" />
    }
    return (
      <div className="cockpit-container">
        <CockpitHeader />
        <div className="cockpit-main">
          <Switch>
            {
              routes.map(route => (
                <RouteWithSubRoutes {...route} key={route.path} />
              ))
            }
            <Redirect to="/cockpit/index" />
          </Switch>
        </div>
      </div>
    )
  })
)

export default CockpitHome